import { render, staticRenderFns } from "./W9CRPersonData.vue?vue&type=template&id=105a621a&scoped=true&"
import script from "./W9CRPersonData.vue?vue&type=script&lang=ts&"
export * from "./W9CRPersonData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105a621a",
  null
  
)

export default component.exports